var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { useResponsive } from '../..';
import { Colors, getSpacing } from '../../constants';
import { Box } from '../Box';
import { Text } from '../Typography';
export var TabsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var SectionContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
export var Tabs = function (_a) {
    var _b = _a.sections, sections = _b === void 0 ? [] : _b, props = __rest(_a, ["sections"]);
    var _c = useState(0), activeTab = _c[0], setActiveTab = _c[1];
    var width = useResponsive().width;
    var isMobile = width < 800;
    // If not specified by props, use internal state
    var currentTab = props.activeTab || activeTab;
    var setCurrentTab = props.setActiveTab || setActiveTab;
    return (_jsxs(Box, { children: [_jsx(Box, __assign({ justifyContent: isMobile ? 'center' : 'flex-start', flexDirection: "row", flexWrap: "wrap" }, { children: sections.map(function (section, index) { return (_jsx(SectionContainer, __assign({ onClick: function () { return setCurrentTab(index); } }, { children: _jsx(Box, __assign({ marginRight: getSpacing('m'), paddingBottom: getSpacing('xs') }, { children: _jsx(Text, __assign({ size: "m", weight: "semi-bold", style: {
                                lineHeight: '21px',
                                color: currentTab === index ? Colors.WHITE : Colors.WHITE_30,
                            } }, { children: section.name }), void 0) }), void 0) }), index)); }) }), void 0), _jsx(Box, __assign({ marginTop: getSpacing('s') }, { children: sections[currentTab].component }), void 0)] }, void 0));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tabs.js.map